/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_FiredInputs */

const en_status_fired = /** @type {(inputs: Status_FiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fired`)
};

const he_status_fired = /** @type {(inputs: Status_FiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נשלח`)
};

/**
* | output |
* | --- |
* | "fired" |
*
* @param {Status_FiredInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const status_fired = /** @type {((inputs?: Status_FiredInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_FiredInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_fired(inputs)
	return he_status_fired(inputs)
});